const initCkeditorByID = (elmID, toolbar='Simple') => {
  CKEDITOR.replace( elmID, { toolbar: toolbar} );
}

window.CkeditorInitialize = {
  initCkeditorByID
}